import { render, staticRenderFns } from "./CorporateCalendar.vue?vue&type=template&id=37aa2743&scoped=true&"
import script from "./CorporateCalendar.vue?vue&type=script&lang=js&"
export * from "./CorporateCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa2743",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
